import React, {Component} from 'react';
import UpdateUserView from "./UpdateUserView";
import {Growl} from "primereact/growl";
import {MaintenanceUsersService} from "../../../../service/maintenance/users/MaintenanceUsersService";
import {UPDATE_USER_ROUTE, USER_PERMISSIONS_ROUTE} from "../../../../utils/constants/RoutesConstants";
import {textWithAccent} from "../../../../utils/formatters/Accent";


export default class UpdateUserContainer extends Component {
    /**
     * Constructor de la clase, se inicializan las variables.
     * Se toma el elemento a editar que viene de la pantalla anterior.
     * @param {jmap} props Argumento que trae los valores iniciales de la clase
     *              Trae el elemento de la pantalla anterior para editar.
     */
    constructor(props) {
        super(props);
        this.maintenanceUsersService = new MaintenanceUsersService();
        this.accountDropDown = React.createRef();
        this.getStatusList = this.getStatusList.bind(this);
        this.getTypeUsrList = this.getTypeUsrList.bind(this);
        this.getDomainList = this.getDomainList.bind(this);
        this.initializeUserData = this.initializeUserData.bind(this);

        this.state = {
            returnPath: this.props.location.state.returnPath,
            newUser: this.props.location.state.newUser,
            isInterno: localStorage.getItem('institution') === 'Interno',
            //statusList: [this.getStatusList('0')],

            userData: {},

            requiredFieldsList: ['usuario', 'nombre', 'apellidoPaterno', 'idTipoUsuario',
                'userEmail', 'idStatus', 'tel1', 'dominio'],
            errors: {},
            instDisabled: true,
            isLoading: false,


        };

        this.onChangeText = this.onChangeText.bind(this);
        this.onChangeDropDown = this.onChangeDropDown.bind(this);
        this.onChangeCheckMfa = this.onChangeCheckMfa.bind(this);
        this.updateUser = this.updateUser.bind(this);
        this.updateUserRegister = this.updateUserRegister.bind(this);
        this.validateRequiredFields = this.validateRequiredFields.bind(this);
        this.getErrors = this.getErrors.bind(this);
        this.returnMaintenanceUsersPage = this.returnMaintenanceUsersPage.bind(this);
        this.redirectPermissions = this.redirectPermissions.bind(this);
        this.loading = this.loading.bind(this);
    }

    componentDidMount() {
        this.initializeUserData(this.props.location.state.newUser);
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : '', message
            });
        }
    }

    /**
     * Función que setea la variable para que se vea la barra de carga
     */
    loading(option) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: option ? option : false,
            });
        }
    }

    initializeUserData(isNewUser) {
        let userDataAux = this.state.userData;
        let isInterno = localStorage.getItem('institution') === 'Interno';
        if (!isNewUser) {
            //Editar
            let selectedUser = this.props.location.state.selectedUser;
            userDataAux['nombre'] = textWithAccent(selectedUser.nombre);
            userDataAux['usuario'] = selectedUser.usuario;
            userDataAux['apellidoPaterno'] = textWithAccent(selectedUser.apellidoPaterno);
            userDataAux['apellidoMaterno'] = textWithAccent(selectedUser.apellidoMaterno);
            userDataAux['telefono1'] = selectedUser.telefono1;
            userDataAux['telefono2'] = selectedUser.telefono2;
            userDataAux['fax'] = selectedUser.telefono3;
            userDataAux['userEmail'] = (selectedUser.correo.split("@"))[0];
            userDataAux['dominio'] = "@" + (selectedUser.correo.split("@"))[1];
            userDataAux['banderaIndeval'] = selectedUser.isIndeval !== 0;
            userDataAux['status'] = selectedUser['status'];
            userDataAux['isMfa'] = selectedUser['isMfa'];
            userDataAux['idInstitucion'] = selectedUser['idInstitucion'];
            userDataAux['correo'] = selectedUser['correo'];

            userDataAux['idTipoUsuario'] = selectedUser.idTipoUsuario;
            userDataAux['tipoUsuario'] = selectedUser.tipoUsuario;
            userDataAux['nombreCorto'] = selectedUser.nombreCorto;

            this.getStatusList(selectedUser['status']);
            this.getDomainList(selectedUser.idInstitucion,
                "@" + (selectedUser.correo.split("@"))[1]);
        } else {
            userDataAux['nombre'] = '';
            userDataAux['usuario'] = '';
            userDataAux['apellidoPaterno'] = '';
            userDataAux['apellidoMaterno'] = '';
            userDataAux['telefono1'] = '';
            userDataAux['telefono2'] = '';
            userDataAux['fax'] = '';
            userDataAux['userEmail'] = '';
            userDataAux['dominio'] = '';
            userDataAux['isMfa'] = false;

            this.getStatusList('A');
            if (!isInterno) {
                this.getDomainList();
                userDataAux['nombreCorto'] = localStorage.getItem('institution');
            }else{
                this.getDomainList(0, '');
            }
            this.getTypeUsrList(isInterno);
            this.setState({dataUsers: this.props.location.state.dataUsers});
        }
        this.setState({
            userData: userDataAux,
        });
    }

    getStatusList(idStatus) {
        this.loading();
        this.maintenanceUsersService.getStatusList()
            .then(res => {
                let userDataAux = this.state.userData;
                let objAux = res.find(
                    item => item['idStatus'] === idStatus);

                userDataAux['statusObj'] = objAux;
                userDataAux['idStatus'] = objAux.idStatus;

                this.setState({
                    statusList: res,
                    userData: userDataAux,
                    isLoading: false,
                });
            });
    }

    getTypeUsrList(isInterno) {
        this.loading();
        this.maintenanceUsersService.getTypeUsrList()
            .then(res => {
                let userDataAux = this.state.userData;
                if (!isInterno) {
                    let objAux = res.find(item =>
                        item['tipoUsuario'] === 'Externo');
                    userDataAux['typeUsrObj'] = objAux;
                    userDataAux['idTipoUsuario'] = objAux.idTipoUsuario;
                    userDataAux['tipoUsuario'] = objAux.tipoUsuario;
                } else {
                    userDataAux['idTipoUsuario'] = '';
                }
                this.setState({
                    typeUsrList: res,
                    isLoading: false,
                    userDataAux: userDataAux,
                });
            });
    }

    getDomainList(idInstitution, domainStr) {
        this.loading();
        this.maintenanceUsersService.getDomainEmailList(idInstitution)
            .then(res => {
                let userDataAux = this.state.userData;
                userDataAux['domainObj'] = res.find((item) =>
                    item['dominio'] === domainStr)
                this.setState({
                    domainList: res,
                    isLoading: false,
                    userData: userDataAux,
                });
            });
    }

    /**
     * Función que maneja el cambio de valor en los campos de texto
     * y los coloca en el state dentro del objeto que se va a editar.
     * @param event Contiene el valor que fue modificado en la vista.
     */
    onChangeText(event) {
        const {name, value} = event.target;
        let userDataAux = this.state.userData;
        userDataAux[name] = value;
        this.setState({userData: userDataAux,})
    }

    /**
     * Función que maneja el cambio en el dropdown de cuenta
     * se guarda la opción elegida en una variable del estado
     * @param event Evento que trae el valor que se eligió.
     */
    onChangeDropDown(event) {
        let {name, value} = event.target;
        value = value ? value : '';
        let userDataAux = this.state.userData;
        userDataAux[name] = value;
        switch (name) {
            case "typeUsrObj":
                userDataAux['instObj'] = '';
                userDataAux['domainObj'] = '';
                userDataAux['idTipoUsuario'] = value['idTipoUsuario'];

                if (value['idTipoUsuario'] === '0') {
                    let requiredFieldsListAux =
                        this.state.requiredFieldsList.filter(elem => {
                            return elem !== 'instObj';
                        });
                    this.setState({
                        domainList: this.getDomainList('0'),
                        instDisabled: true,
                        requiredFieldsList: requiredFieldsListAux,
                    });
                } else {
                    let requiredFieldsListAux = this.state.requiredFieldsList;
                    requiredFieldsListAux.push('instObj');
                    this.setState({
                        domainList: [],
                        instDisabled: false,
                        requiredFieldsList: requiredFieldsListAux,
                    });
                }
                break;
            case "instObj":
                userDataAux['domainObj'] = '';
                userDataAux['nombreCorto'] = value['nombreCorto'];
                userDataAux['idInstitucion'] = value['idInstitucion'];
                let listDomains = value === '' ? [] :
                    this.getDomainList(value['idInstitucion']);
                this.setState({
                    domainList: listDomains,
                });
                break;
            case "domainObj":
                userDataAux['dominio'] = value['dominio'];
                break;
            case "statusObj":
                userDataAux['idStatus'] = value['idStatus'];
                break;
            default:
                break;
        }
        this.setState({userData: userDataAux,})
    }

    onChangeCheckMfa(event) {
        const {name, checked} = event.target;
        let userDataAux = this.state.userData;
        userDataAux[name] = checked;
        userDataAux['isMfa'] = checked ? 1 : 0;
        this.setState({userData: userDataAux,})
    }

    /**
     * Función que consume a CaptureGuaranteesService para guardar los datos
     * del elemento nuevo.
     * Se hace una validación que estén presentes los datos obligatorios.
     */
    updateUser() {
        this.loading();
        this.getErrors();
        if (!this.validateRequiredFields()) {
            if (this.state.newUser) {
                let objAux = this.state.dataUsers.find(
                    item => item['usuario'] === this.state.userData.usuario);
                objAux ?
                    this.growl.show({severity: 'error', summary: 'Error.', detail: 'El usuario ya existe.'}) :
                    this.updateUserRegister();
            } else {
                this.updateUserRegister();
            }
        } else {
            this.growl.show({severity: 'error', summary: 'Error.', detail: 'Llenar correctamente los campos requeridos'});
        }
    }

    updateUserRegister() {
        this.maintenanceUsersService.updateUser(this.state.userData)
            .then(resp => {
                let messageObj = {};
                let message = resp.message;
                let error = resp.error;
                if (message === 'Success') {
                    messageObj['severity'] = 'success';
                    messageObj['sumary'] = 'Éxito';
                    messageObj['detail'] = this.state.newUser ?
                        'El Usuario se ha insertado exitosamente.' :
                        'El Usuario se ha modificado exitosamente.';
                    this.returnMaintenanceUsersPage(messageObj);
                } else if (error !== "") {
                    this.growl.show({severity: 'error', summary: 'Error.', detail: error});
                }
            });
    }

    validateRequiredFields() {
        let result = false;
        this.state.requiredFieldsList.forEach(field => {
            if (this.state.userData[field] === '' || (field === 'userEmail' && this.state.userData[field].includes('@'))) {
                result = true;
                return true;
            }
        });
        return result;
    }

    getErrors() {
        let mapErrors = {};
        this.state.requiredFieldsList.forEach(field => {
            mapErrors[field] = this.state.userData[field] === '' || !this.state.userData[field] ||
                (field === 'userEmail' && this.state.userData[field].includes('@'));
        });
        this.setState({errors: mapErrors});
    }

    /**
     * Función que regresa a la pantalla de Captura de Garantías
     */
    returnMaintenanceUsersPage(message) {
        this.setState({isLoading: false,});
        this.props.history.push({
            pathname: this.state.returnPath,
            message: message,
        });
    }

    /**
     * Función que redirecciona a la pantalla de editar
     */
    redirectPermissions() {
        this.props.history.push({
            pathname: USER_PERMISSIONS_ROUTE,
            state: {
                returnPath: UPDATE_USER_ROUTE,
                selectedUser: this.state.userData,
            },
        });
    }

    /**
     * Función que realiza el render de la pantalla cuando existe un cambio.
     * En esta se le pasa a la vista lo que necesita para pintarse.
     * @returns {*}
     */
    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {
            userData, isLoading, statusList, typeUsrList,
            domainList, instDisabled, errors, isInterno,
            newUser
        } = this.state

        return (
            <UpdateUserView
                userData={userData}
                messagesGrowl={messagesGrowl}
                isLoading={isLoading}
                statusList={statusList}
                typeUsrList={typeUsrList}
                domainList={domainList}
                instDisabled={instDisabled}
                errors={errors}
                isInterno={isInterno}
                newUser={newUser}
                accountDropDown={this.accountDropDown}
                loading={this.loading}
                onChangeText={this.onChangeText}
                onChangeDropDown={this.onChangeDropDown}
                onChangeCheckMfa={this.onChangeCheckMfa}
                updateUser={this.updateUser}
                returnMaintenanceUsersPage={this.returnMaintenanceUsersPage}
                redirectPermissions={this.redirectPermissions}
            />
        );
    }
}
